import * as React from "react";

import "./PatientHeader.scss";

export default function() {
  return (
    <div className="patient-header">
      <div className="header-icon flex-justify-center">
        <i className="fa fa-lock"></i>
      </div>
      <div className="flex-1 flex-justify-center">
        <div className="logo ch-logo"></div>
      </div>
      <div className="header-icon flex-justify-center">
        <i className="fas fa-bars"></i>
      </div>
    </div>
  );
}
